// src/Components/Forms/Financement/Salam/Reception/Tab2.tsx
import React from 'react';
import { Box } from '@mui/material';
import SetMultipleDocument from '../../../../SetMultipleDocument';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';

let searchDocument: ParamsPicklist = {
  CodeAgence: 'SALAM',
  Table: 'vw_DocumentsParEtape',
  Colonne1: 'CodeEtape',
  Colonne2: '',
  Colagence: 'CodeProcessus',
  Init: 'RECEPTION',
  Choix: 34,
};

const Tab2 = (props: { form?: any }) => {
  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={'85%'} position={'absolute'}>
        <SetMultipleDocument
          form={props.form}
          Size="large"
          width={4}
          label="Documents réception"
          name="DocumentsReception"
          Parametre={searchDocument}
          disabled={false}
        />
      </Box>
    </div>
  );
};

export default Tab2;